const TEXT_FIELD_SELECTOR = 'textarea, input:not([type]), input[type="text"], input[type="search"]';

export const enableTextSuggestions = (field) => {
  if (!(field instanceof Element) || !field.matches(TEXT_FIELD_SELECTOR)) return false;
  field.setAttribute('autocomplete', 'on');
  if (!field.hasAttribute('autocapitalize')) field.setAttribute('autocapitalize', 'sentences');
  field.setAttribute('spellcheck', 'true');
  return true;
};

const enableInTree = (node) => {
  if (!(node instanceof Element)) return;
  enableTextSuggestions(node);
  node.querySelectorAll(TEXT_FIELD_SELECTOR).forEach(enableTextSuggestions);
};

export const installTextSuggestions = (documentRoot = document) => {
  const root = documentRoot.body || documentRoot.documentElement;
  if (!root || typeof MutationObserver === 'undefined') return () => {};

  enableInTree(root);
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(enableInTree));
  });
  observer.observe(root, { childList: true, subtree: true });

  const reinforceOnFocus = (event) => enableTextSuggestions(event.target);
  documentRoot.addEventListener('focusin', reinforceOnFocus, true);

  return () => {
    observer.disconnect();
    documentRoot.removeEventListener('focusin', reinforceOnFocus, true);
  };
};
